import React, { useState, useMemo } from 'react'
import { Popover, message } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import { BatchItem } from 'component'
import { request } from 'meinian-package/src/utils'
import moment from 'moment'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import classNames from 'classnames'
import ImageDetail from 'view/detail/imageDetail'
import RecordInfoCard from 'component/waterfall.card/marking/recordInfoCard'
import { Dropdown, Ul, Li } from 'meinian-package/src/baseComponent'
import getBoxLabelRetList from 'common/getBoxLabelRetList'
import styles from './index.module.less'

const Card = ({
  columnWidth,
  infoHeight = 0,
  onClickCard,
  total,
  data,
  isBatch,
  onFeedback,
  action,
  itemData,
  ...props }) => {
  const {
    source,
    mainUrl,
    unionId,
    sourceTime,
    boxLabelRetList,
    width,
    height,
    collectId,
    recognizeStatus,
    imageGroupEntityId,
    inspirationId,
  } = itemData || {}

  const [lastRouter] = useState(location.pathname + location.search)
  const [visible, setVisible] = useState(false)
  const result = getBoxLabelRetList(boxLabelRetList)

  const categorys = useMemo(() => {
    const _result = result?.map(i => i.category)
    return _result.join('、')
  }, [result])

  const [visibleDetail, setVisibleDetail] = useState(false)

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
    }
  }

  const recognizeStatusEnum = {
    0: '识别中...',
    1: categorys,
    2: '识别失败'
  }

  const remote = () => {
    ModalConfirm.show({
      title: '确认删除',
      content: '是否删除当前识别记录？',
      onOk: async () => {
        request.post('/zhikuan/intelligence-tag/delete', { unionIdList: [unionId] }).then(success => {
          if (success) {
            message.success('删除成功')
            props.initSubColls && props.initSubColls()
            action.onDelete([imageGroupEntityId, inspirationId])
            props.onResize()
          }
        })
      },
    })
  }

  const sourceEnum = {
    1: '上传图片',
    2: '上传款式'
  }

  return <div
    className={styles.markIngCard}
    style={{
      width: columnWidth,
      height: width ? Math.round((columnWidth * height) / width) + infoHeight : columnWidth,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <Popover
      destroyTooltipOnHide={{ keepParent: false }}
      visible={visible}
      onVisibleChange={vis => {
        if (!isBatch) {
          setVisible(vis)
        }
      }}
      placement="rightTop"
      overlayClassName={styles.markIngCardPopover}
      content={<RecordInfoCard
        boxLabelRetList={result}
        onFeedback={() => {
          setVisible(false)
          onFeedback({
            mainUrl,
            unionId,
            boxLabelRetList: result
          })
        }}
      />}
    >
      <div onClick={(e) => {
        e.stopPropagation()
        if (onClickCard) {
          onClickCard(itemData, e)
        } else if (source === 2 && !isBatch) {
          history.replaceState({}, '', `/meinian/detail/image?imageGroupEntityId=${imageGroupEntityId}&inspirationId=${inspirationId}&collectId=${collectId}`)
          setVisibleDetail(true)
        }
      }}
      >
        <div className={styles.markIngCardWrapperImage}>
          <img
            className={styles.markIngCardWrapperImage}
            src={mainUrl}
          />
          {!isBatch ? <div className={styles.markIngCardAction}>
            <Dropdown
              trigger="hover"
              getPopupContainer={() => document.body}
              overlay={<Ul
                style={{ width: 150 }}
                ulProps={{
                  onClick: (e) => {
                    e.stopPropagation()
                  }
                }}
              >
                <Li className="mn-dropdown-icon-li delete" onClick={() => remote()}><Icon type="m-shanchu" />删除</Li>
              </Ul>}
              placement="bottomRight"
              className="mn-image-card-operation"
            >
              <span
                style={{ padding: '4px 6px', borderRadius: 6, backgroundColor: '#fff', border: '1px solid var(--m-fill-3)' }}
              ><Icon type="m-gengduo" /></span>
            </Dropdown>
          </div> : <div className={styles.markIngCardActionBatchMask}>
            <BatchItem keyValue={unionId} className={styles.batchCheck} />
          </div>}
          <div className={styles.markIngCardSource}>{sourceEnum[source]}</div>
        </div>
      </div>
    </Popover>
    <div className={styles.markIngCardFooter}>
      <div>{moment(sourceTime).format('YYYY-MM-DD')}</div>
      {
          recognizeStatusEnum[recognizeStatus] && <div
            className={classNames(styles.markIngCardFooterLabel, { [styles.in]: !recognizeStatus })}
          >{recognizeStatusEnum[recognizeStatus]}</div>
        }
    </div>
    {visibleDetail ? <ImageDetail
      list={data}
      maxListLength={total || data.length}
      onChangeIndex={props.onChangeIndex}
      visible={visibleDetail}
      onChange={_onChange}
      onVisibleChange={(_visible) => {
        history.replaceState({}, '', lastRouter)
        setVisibleDetail(_visible)
      }}
      onDeleteItem={(record) => {
        action.onDelete([record.imageGroupEntityId, record.inspirationId])
        props.onResize()
      }}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}
export default Card
